import { makeStyles } from '@material-ui/core';
import { Colors } from '../../../../utils';

const makeClasses = makeStyles((theme) => ({
  formSelectLabel: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentTextSoft,
    fontSize: theme.fontSize.L,
  },
  formSelect: {
    width: '100%',

    '&:before': {
      borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted}`,
    },
    '&:after': {
      borderBottom: `1px solid ${Colors.rgb.primary}`,
    },
    '&:hover': {
      '&:before': {
        borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted} !important`,
      },
    },

    '& > div': {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentText,
      fontSize: theme.fontSize.L,
    },
  },
  formInput: {
    width: '100%',

    '& > label': {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentTextSoft,
      fontSize: theme.fontSize.L,
    },

    '& > div:before': {
      borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted}`,
    },
    '& > div:after': {
      borderBottom: `1px solid ${Colors.rgb.primary}`,
    },
    '& > div:hover': {
      '&:before': {
        borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted} !important`,
      },
    },

    '& input': {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentText,
      fontSize: theme.fontSize.L,
    },
  },
  formSelectOption: {
    color: Colors.rgb.contentText,
    fontSize: theme.fontSize.M,
    fontFamily: theme.fontFamily.regular,
  },

  userFormWrapper: {
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${Colors.rgb.contentLineSoft}`,
  },
  userForm: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
  },
  userFormInput: {
    width: '100%',

    '& > label': {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentTextSoft,
      fontSize: theme.fontSize.L,
    },

    '& > div:before': {
      borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted}`,
    },
    '& > div:after': {
      borderBottom: `1px solid ${Colors.rgb.primary}`,
    },
    '& > div:hover': {
      '&:before': {
        borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted} !important`,
      },
    },

    '& input': {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentText,
      fontSize: theme.fontSize.L,
    },
  },
  userFormInputEndAdornment: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentTextSoft,
    fontSize: theme.fontSize.S,
  },
  userFormInputSeparator: {
    height: theme.spacing(4),
  },
  userFormSelectLabel: {
    fontFamily: theme.fontFamily.regular,
    color: Colors.rgb.contentTextSoft,
    fontSize: theme.fontSize.L,
  },
  userFormSelect: {
    width: '100%',

    '&:before': {
      borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted}`,
    },
    '&:after': {
      borderBottom: `1px solid ${Colors.rgb.primary}`,
    },
    '&:hover': {
      '&:before': {
        borderBottom: `1px solid ${Colors.rgb.contentLineHighlighted} !important`,
      },
    },

    '& > div': {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentText,
      fontSize: theme.fontSize.L,
    },
  },
  userFormSelectOption: {
    color: Colors.rgb.contentText,
    fontSize: theme.fontSize.M,
    fontFamily: theme.fontFamily.regular,
  },
  productImagePreview: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    cursor: 'pointer',
  },
  productImage: {
    width: 148,
    height: 148,
    objectFit: 'cover',
    borderRadius: 5,
    border: `2px solid ${Colors.rgb.contentLineHighlighted}`,
    boxSizing: 'border-box',
  },
  productImagePlaceholder: {
    width: 148,
    height: 148,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `1px dashed ${Colors.rgb.primary}`,
    borderRadius: 5,
  },
  contentActionsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: theme.spacing(4),

    '& > button:last-child': {
      marginRight: 0,
    },
  },
  contentActionSeparator: {
    width: theme.spacing(3),
  },

  //

  table: {},
  tableHeaderCell: {
    fontFamily: theme.fontFamily.bold,
  },
  tableBodyCell: {
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    borderBottomColor: Colors.rgba(Colors.rgb.contentLineSoft, 60),
  },
  //

  boxContainer: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginLeft: `-${theme.spacing(2)}`,
    marginRight: `-${theme.spacing(2)}`,
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    background: Colors.rgb.grey,

    [theme.breakpoints.down('sm')]: {
      borderBottom: `1px solid ${Colors.rgb.contentLineSoft}`,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),

      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
  boxContainerCheckboxWrapper: {
    marginRight: theme.spacing(3),
  },
  boxContainerEven: {
    background: Colors.rgb.white,
  },
  boxItemSeparator: {
    height: 1,
    width: '100%',
    background: Colors.rgb.contentLineSoft,
    margin: `${theme.spacing(3)} 0`,
  },
  boxItem: {
    display: 'flex',
    marginBottom: theme.spacing(1),

    '& > span': {
      fontFamily: theme.fontFamily.regular,
      color: Colors.rgb.contentTextSoft,

      '&:last-child': {
        marginLeft: theme.spacing(2),
        color: Colors.rgb.contentText,
      },
    },

    '&:last-child': {
      marginBottom: 0,
    },

    [theme.breakpoints.down('sm')]: {
      '& > span': {
        fontSize: theme.fontSize.M,
      },
    },
  },
  boxItemCompact: {
    fontSize: theme.fontSize.M,
  },
  alert: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)} !important`,
    width: '100%',
    boxSizing: 'border-box',

    '& > div': {
      display: 'flex',
      alignItems: 'center',
    },

    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(1)} !important`,
      '& > div': {
        alignItems: 'flex-start',
      },
    },
  },
  alertTitle: {
    fontFamily: theme.fontFamily.bold,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.fontSize.M,
    },
  },
  alertMessage: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.fontSize.S,
    },
  },
  alertIcon: {
    fontSize: 50,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: 40,
    },
  },
  alertInfo: {
    background: Colors.rgb.alertInfoBackground,
    border: `1px solid ${Colors.rgb.alertInfoBorder}`,
    color: `${Colors.rgb.alertInfoText} !important`,
  },
  posDescriptionAlert: {
    '& > div': {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
  },
  posDescriptionAlertIcon: {
    fontSize: 30,
  },
  posDescriptionAlertTitle: {
    fontSize: theme.fontSize.M,
  },
  posDescriptionAlertMessage: {
    fontSize: theme.fontSize.S,
  },
  posDescriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100%',
  },
}));

export default makeClasses;
